import { useEffect, useState } from "react";
import { Download, FileDown } from "lucide-react";
import { api } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import SEO from "../../components/SEO";
import { downloadAction } from "../../lib/downloads";

const TYPE_LABEL = {
  software: "Yazılım",
  driver: "Sürücü",
  other: "Diğer",
};

export default function SoftwarePage() {
  const { mode, brand } = useBrand();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      const baseParams = new URLSearchParams();
      if (mode === "brand" && brand) baseParams.set("brand_slug", brand.slug);
      const types = ["software", "driver", "other"];
      const results = await Promise.all(
        types.map((t) => {
          const p = new URLSearchParams(baseParams);
          p.set("type", t);
          return api.get(`/downloads?${p.toString()}`).then((r) => r.data);
        })
      );
      setItems(results.flat());
    };
    load();
  }, [mode, brand]);

  const grouped = items.reduce((acc, it) => {
    const k = TYPE_LABEL[it.type] || "Diğer";
    acc[k] = acc[k] || [];
    acc[k].push(it);
    return acc;
  }, {});

  return (
    <div className="fade-in-up" data-testid="software-page">
      <SEO title="Yazılımlar & Sürücüler" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Destek</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Yazılımlar & Sürücüler</h1>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {items.length === 0 ? (
          <div className="text-center py-20 text-zinc-500" data-testid="software-empty">
            Henüz dosya eklenmemiş.
          </div>
        ) : (
          <div className="space-y-10" data-testid="software-list">
            {Object.entries(grouped).map(([label, list]) => (
              <div key={label}>
                <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">{label}</div>
                <div className="border border-white/10 bg-[#0A0A0A]">
                  {list.map((d, idx) => (
                    <button
                      key={d.id}
                      onClick={() => downloadAction(d)}
                      className={`w-full flex items-center gap-3 px-4 py-4 hover:bg-white/5 text-left ${
                        idx > 0 ? "border-t border-white/5" : ""
                      }`}
                      data-testid={`software-item-${d.id}`}
                    >
                      <FileDown size={16} className="text-zinc-500 shrink-0" />
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium truncate">{d.title}</div>
                        <div className="text-xs text-zinc-500 mt-0.5">
                          {d.group && <span className="mr-3">{d.group}</span>}
                          {d.version && <span>{d.version}</span>}
                        </div>
                      </div>
                      <Download size={16} className="text-zinc-400 shrink-0" />
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
